const ReloadViewModule = {
  
  deliveryScheduleSideNavModel: undefined,

  async reload() {
    const loader = this.deliveryScheduleSideNavModel.get('loader');
    const loaderOptions = this.deliveryScheduleSideNavModel.get('loaderOptions');

    await this.deliveryScheduleSideNavModel.get('view').initialize({ viewPromise: loader(loaderOptions)});
  }
};

export default ReloadViewModule;